import { Dialog } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import ProDetailsItem from 'components/foundation/details-item/ProDetailsItem/ProDetailsItem';
import { useOpenable } from 'hooks';
import { t } from 'i18next';

import IPosition from 'types/Position';
import { budgetsStatusString, manageBudgetType } from 'utils/positionUtils';
import BudgetForm from '../forms/BudgetForm';

export interface IBudgetDetailProps {
  editable: boolean;
  position: IPosition;
  onUpdate: () => Promise<any>;
  className?: ClassName;
}

const BudgetDetail = (props: IBudgetDetailProps) => {
  const { position, onUpdate, editable, className } = props;

  const editTitleDialog = useOpenable();

  function onSubmit() {
    editTitleDialog.close();
    onUpdate();
  }

  const classes = classNames('budget-detail', className);

  return (
    <>
      <ProDetailsItem
        title={t('Budgets')}
        onClick={editTitleDialog.open}
        value={budgetsStatusString(position)}
        hint={
          'View, create, edit and delete project budgets. Optionally allow the user to view, but not modify, budgets.'
        }
        className={classes}
        disabled={!editable}
      />
      <Dialog position={'center'} isOpen={editTitleDialog.isOpen} onClose={editTitleDialog.close}>
        <BudgetForm
          className="mt-4 p-8"
          onSubmit={onSubmit}
          positionId={position.id}
          currentSetting={manageBudgetType(position)}
        />
      </Dialog>
    </>
  );
};

export default BudgetDetail;
